<template>
  <div class="print-selfevaluation">
    <el-row class="print-declarationInfo__control" type="flex" justify="end">
      <el-button style="margin-right: 20px;" type="primary" @click="handlePrint">打印</el-button>
    </el-row>
    <div class="print-selfevaluation__box">
      <selfevaluation-check :in-print="inPrint" ref="selfevaluationCheck">
        <div slot="title" class="print-selfevaluation__title">自评表管理</div>
      </selfevaluation-check>
      <div class="print-selfevaluation__bottom">
        <span>
          供应商签名
          <span class="line"></span>
        </span>
        <span>
          赫基供应链签名
          <span class="line"></span>
        </span>
        <span>
          打印日期
          <span class="line">{{this.$utils.formatTime(new Date(), '{y}/{m}/{d}')}}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import selfevaluationCheck from "./detail.vue";
import { createIframePrint } from "src/common/print";

export default {
  name: "print-selfevaluation",
  components: {
    selfevaluationCheck
  },
  computed: {},
  data() {
    return {
      inPrint: false
    };
  },
  methods: {
    handlePrint() {
      const ele = document.querySelector(".print-selfevaluation__box");
      this.inPrint = true;
      setTimeout(() => {
        createIframePrint(ele).then(() => {
          this.inPrint = false;
        });
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
@import "src/sass/index";
.print-selfevaluation {
  position: fixed;
		overflow-y: scroll;
		height: 100vh;
    width: 100%;
  .print-selfevaluation__title {
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
  }
  .print-selfevaluation__bottom {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 20px 0;
    .line {
      position: relative;
      &:before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        border: 1px solid #999;
        border-top: none;
        height: 0;
      }
      text-align: center;
      width: 150px;
      display: inline-block;
    }
  }
  * {
    font-size: 20px;
  }
  tr {
    td {
      div {
        white-space: normal !important;
      }
    }
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    width: 18px;
    height: 20px;
    background-color: #DCDFE6;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    position: absolute;
    content: "";
    top: 1px;
    left: 3px;
    width: 7px;
    height: 6px;
    transform: rotate(
    45deg
    );
    background-color: #DCDFE6;
    border-color: #DCDFE6;
    z-index: 1;
  }
  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::before {
    position: absolute;
    content: "";
    top: 2px;
    left: 2px;
    width: 12px;
    height: 12px;
    transform: rotate(45deg);
    background-color: #fff;
    border: none;
    z-index: 1;
  }
}
</style>

